const menu = {
    label: 'Eventos',
    icon: 'pi pi-fw pi-calendar',
    to: '/checkins/eventos',
    rules: ['CHECKINS-EVENTOS-00'],
};

export default menu;
